import { types } from "mobx-state-tree";
import { isSupportedLanguage } from "../i18n/types";
import { browserLanguageCode } from "../lib/intlUtils";
export const defaultLanguage = "de";
export const model = types
    .model({
    language: types.enumeration([
        "de",
        "en",
        "browserLanguage",
    ]),
    compact: types.model({
        enabled: types.maybeNull(types.boolean),
        breakpointValue: types.maybeNull(types.number),
    }),
})
    .actions((self) => ({
    setLanguage: (lang) => {
        self.language = lang;
    },
    toggleCompactMode: () => {
        self.compact.enabled = !self.compact.enabled;
    },
    enableCompactMode: () => (self.compact.enabled = true),
    disableCompactMode: () => (self.compact.enabled = false),
    detectCompactMode: () => {
        const breakPointValue = self.compact.breakpointValue;
        if (breakPointValue) {
            self.compact.enabled = window.innerWidth < breakPointValue;
        }
    },
}))
    .actions((self) => ({
    initSettings: (breakpoint) => {
        self.compact.breakpointValue = breakpoint;
        self.detectCompactMode();
    },
}))
    .views((self) => ({
    /** This will return the current language that is like to be used. */
    getLanguage: () => {
        return self.language === "browserLanguage"
            ? browserLanguageCode
            : self.language;
    },
    /**
     * Will return the resolved language. Either the fixed language or if
     * browser language is used the extracted language key. The returned
     * language key is available in the i18n translate object.
     */
    getResolvedLanguage: () => {
        if (self.language === "browserLanguage") {
            if (!isSupportedLanguage(browserLanguageCode)) {
                return defaultLanguage;
            }
            return browserLanguageCode;
        }
        return self.language;
    },
}));
export const settingsStore = model.create({
    language: defaultLanguage,
    compact: {
        enabled: null,
        breakpointValue: null,
    },
});
export default settingsStore;
//# sourceMappingURL=data:application/json;base64,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